export const gruender = {
  name: 'Ilker Sahin',
  role: 'Geschäftsführer & Gründer',
  tagline: 'Der Mann hinter IGM facility service',
  image: 'https://static.readdy.ai/image/42a59d03aabdb3bbb4adf980fce8c22a/8af539e3f70f99ed0ee7523e7c61a4aa.jpeg',
  quote: 'Ich wollte nicht mehr für Betriebe arbeiten, die Qualität nur predigen. Ich wollte beweisen, dass man es wirklich so machen kann — zuverlässig, ehrlich und mit echtem Handwerk.',
  bio: 'Ilker Sahin weiß, wie ein Gebäude wirklich funktioniert — von der Heizung im Keller bis zum Putz an der Fassade. Jahrelang arbeitete er in der Bau- und Facilitybranche, sammelte Erfahrung auf Baustellen, in der Gebäudetechnik und im operativen Betrieb von Immobilien. Er kannte beide Seiten: die handwerkliche Umsetzung und die Steuerung ganzer Objekte.',
  motivation: '2021 war der Zeitpunkt gekommen. Er hatte genug gesehen — wie Qualität auf dem Papier steht, aber nicht auf der Baustelle. Gemeinsam mit erfahrenen Kollegen, die denselben Anspruch teilen, gründete er IGM Facility Service. Kein Risikosprung ins Unbekannte, sondern ein durchdachter Schritt auf solidem Fundament: eigenes Know-how, ein verlässliches Team und der klare Wille, es besser zu machen.',
  phone: '+49 2102 7398070',
  email: 'kontakt@igmfacilityservice.de',
  skills: ['Gebäudeinstandhaltung', 'Projektleitung', 'Facility Management', 'Qualitätssicherung', 'Kundenbetreuung', 'Partnermanagement'],
  career: [
    { year: '2018–2021', label: 'Objektleiter Facility', desc: 'Verantwortung für komplette Gebäudeobjekte — Instandhaltung, Dienstleistersteuerung, Kundenkontakt.' },
    { year: '2021', label: 'Gründung Amaterasu Facility', desc: 'Der Schritt in die Selbständigkeit: Gründung von Amaterasu Facility — mit eigenem Team, klarer Vision und vollem Einsatz.' },
    { year: '2024', label: 'Fusion & Übernahme IGM Facility Service', desc: 'Zusammenschluss mit IGM Facility Service. Die Marke bleibt — unter dem etablierten Namen IGM Facility Service geht es gemeinsam weiter.' },
    { year: '2026', label: 'Neue Sparte: Bau & Sanierungsdienste', desc: 'Mit neuer Verstärkung im Team wird die Sparte Bau- und Sanierungsdienste offiziell eröffnet — ein weiteres starkes Standbein.' },
  ],
};

export const teamMembers = [
  {
    id: 1,
    name: 'Ilker Sahin',
    role: 'Geschäftsführer & Gründer',
    description: 'Mit jahrelanger Berufserfahrung in der Bau- und Facilitybranche gründete Ilker 2021 IGM Facility Service — und verwandelte sein Know-how in ein verlässliches Unternehmen mit klarer Vision. Er steht für Qualität, Direktheit und einen Betrieb, der hält was er verspricht.',
    image: 'https://public.readdy.ai/ai/img_res/7d7fc6cd0beb4485bea9ac4aee75140f.jpg',
    skills: ['Projektleitung', 'Qualitätssicherung', 'Kundenbetreuung'],
    phone: '+49 2102 7398070',
  },
  {
    id: 2,
    name: 'Semih K.',
    role: 'Bauleiter Sanierung & Renovierung',
    description: 'Semih koordiniert alle Sanierungs- und Renovierungsprojekte mit militärischer Präzision. Sein technisches Know-how und sein Gespür für Effizienz sorgen dafür, dass Projekte stets termingerecht und budgetkonform abgeliefert werden.',
    image: 'https://readdy.ai/api/search-image?query=professional%20construction%20site%20manager%20male%20portrait%20confident%20smile%20hardhat%20background%20clean%20studio%20light%20natural%20warm&width=400&height=450&seq=team-002&orientation=portrait',
    skills: ['Bausanierung', 'Trockenbau', 'Projektkoordination'],
    phone: '+49 2102 7398071',
  },
  {
    id: 3,
    name: 'F. Akcora',
    role: 'Leiter Garten- & Landschaftsbau',
    description: 'F. Akcora verwandelt Außenbereiche in echte Wohlfühloasen. Mit fundierter Praxis im GalaBau leitet er das Gartenteam und bringt jedes Außenprojekt zum Blühen — von der Terrasse bis zur Grünflächenpflege.',
    image: '',
    skills: ['Landschaftsplanung', 'Pflasterarbeiten', 'Grünpflege'],
    phone: '+49 2102 7398072',
  },
  {
    id: 4,
    name: 'D. Akcora',
    role: 'Bauzeichnung & Planung',
    description: 'D. Akcora bringt die planerische Kompetenz ins Team. Sie erstellt präzise Bauzeichnungen und Entwürfe, berät Kunden bei Raumkonzepten und begleitet Genehmigungsprozesse von Anfang bis Ende.',
    image: '',
    skills: ['Bauzeichnung', 'Raumplanung', 'Genehmigungsplanung'],
    phone: '+49 2102 7398073',
  },
  {
    id: 5,
    name: 'Richard M.',
    role: 'Allrounder & Handwerk',
    description: 'Richard ist unser Mann für alles — egal ob Bodenbeläge, Malerarbeiten, Kleinreparaturen oder spontane Einsätze auf der Baustelle. Er packt überall mit an, wo Hilfe gebraucht wird, und liefert dabei stets saubere Arbeit.',
    image: '',
    skills: ['Bodenbeläge', 'Malerarbeiten', 'Kleinreparaturen', 'Handwerk'],
    phone: '+49 2102 7398074',
  },
  {
    id: 6,
    name: 'I. Yalcin',
    role: 'Büroleitung & Kundenservice & Auftragskoordination',
    description: 'I. Yalcin ist die erste Ansprechpartnerin für alle Kunden — von der ersten Anfrage bis zur Rechnungsstellung. Mit strukturiertem Arbeitsansatz sorgt sie dafür, dass kein Auftrag verloren geht und jeder Kunde bestens betreut wird.',
    image: '',
    skills: ['Büroleitung', 'Kundenmanagement', 'Auftragskoordination'],
    phone: '+49 2102 7398070',
  },
  {
    id: 7,
    name: 'Y. Yalcin',
    role: 'Hausmeister & Grünpflege',
    description: 'Y. Yalcin kümmert sich zuverlässig um die Haustechnik und Grünpflege unserer Objekte. Von der schnellen Kleinreparatur bis zur regelmäßigen Pflege der Außenanlagen — er hält alles in Ordnung.',
    image: '',
    skills: ['Haustechnik', 'Grünpflege', 'Instandhaltung'],
    phone: '+49 2102 7398075',
  },
  {
    id: 8,
    name: 'K. Sahin',
    role: 'Hausmeister & Objektleiter',
    description: 'K. Sahin übernimmt die Objektleitung und Hausmeisterdienste für unsere betreuten Liegenschaften. Mit einem wachen Blick für Details und hoher Einsatzbereitschaft sorgt er dafür, dass alles reibungslos läuft.',
    image: '',
    skills: ['Objektleitung', 'Hausmeisterdienste', 'Wartung'],
    phone: '+49 2102 7398076',
  },
];

export const milestones = [
  {
    year: 'Die Wurzeln',
    title: 'Jahrelange Berufserfahrung im Gepäck',
    description: 'Die Gründer von IGM bringen jahrelange, teils jahrzehntelange Erfahrung aus der Bau-, Facility- und Reinigungsbranche mit. Handwerk, Projektleitung und Kundenkontakt — alles gelernt, alles gelebt. Irgendwann war der Zeitpunkt gekommen, den Schritt in die Selbständigkeit zu wagen.',
    icon: 'ri-user-star-line',
  },
  {
    year: '2021',
    title: 'Gründung Amaterasu Facility',
    description: 'Mit gebündelter Berufserfahrung und dem Mut zur Eigenverantwortung wird Amaterasu Facility gegründet. Die Vision: ein verlässlicher Rundum-Dienstleister für Gebäude aller Art — von der Instandhaltung über Renovierung bis zur professionellen Reinigung. Alles aus einer Hand.',
    icon: 'ri-flag-line',
  },
  {
    year: '2022',
    title: 'Erste eigene Sparten & Partnernetzwerk aufbauen',
    description: 'Die ersten Leistungsbereiche werden strukturiert etabliert: Gebäudeinstandhaltung, Renovierung & Erneuerung sowie Gebäudereinigung. Für spezialisierte Gewerke werden gezielt starke Partnerunternehmen gewonnen — Fachbetriebe, auf die man sich blind verlassen kann.',
    icon: 'ri-building-4-line',
  },
  {
    year: '2023',
    title: 'Wachstum & erste Gewerbekunden',
    description: 'Das Leistungsspektrum überzeugt: Gewerbliche Kunden, Hausverwaltungen und Wohnungsbaugesellschaften setzen auf uns als zuverlässigen Facility-Partner. Das Team wächst, die Auftragslage ist stabil.',
    icon: 'ri-handshake-line',
  },
  {
    year: '2024',
    title: 'Fusion & Übernahme von IGM Facility Service',
    description: 'Ein starker Zusammenschluss: Amaterasu Facility fusioniert mit IGM Facility Service. Das gemeinsame Know-how und die erweiterten Kapazitäten schaffen ein noch stärkeres Unternehmen — weitergeführt unter dem etablierten Namen IGM Facility Service.',
    icon: 'ri-merge-cells-horizontal',
  },
  {
    year: '2025',
    title: 'Volle Vorbereitung auf 2026',
    description: 'Neue Partnerschaften, gezielter Teamaufbau und intensive Vorbereitung auf den nächsten großen Schritt: die Eröffnung der Sparte Bau- & Sanierungsdienste. IGM wächst bewusst — strukturiert, mit klarem Ziel vor Augen.',
    icon: 'ri-rocket-line',
  },
  {
    year: '2026',
    title: 'Neue Sparte: Bau- & Sanierungsdienste',
    description: 'Mit frischer Verstärkung im Team wird die neue Sparte Bau- und Sanierungsdienste offiziell eröffnet. Ein weiteres starkes Standbein — und der nächste Schritt zur umfassenden Gebäudekompetenz aus einer Hand.',
    icon: 'ri-hammer-line',
  },
];

export const coreValues = [
  {
    id: 1,
    icon: 'ri-shield-check-line',
    title: 'Qualität ohne Kompromisse',
    description: 'Jedes Projekt wird mit höchsten handwerklichen Standards ausgeführt. Wir verwenden ausschließlich geprüfte Materialien und arbeiten zertifiziert nach DIN EN ISO 9001.',
  },
  {
    id: 2,
    icon: 'ri-handshake-line',
    title: 'Verlässlichkeit & Transparenz',
    description: 'Termine werden eingehalten, Preise vorab klar kommuniziert. Kein versteckter Mehraufwand, keine bösen Überraschungen — das ist unser Versprechen.',
  },
  {
    id: 3,
    icon: 'ri-user-heart-line',
    title: 'Kundennähe',
    description: 'Wir hören zu, bevor wir handeln. Jedes Projekt wird individuell geplant — abgestimmt auf die Wünsche und das Budget unserer Kunden.',
  },
  {
    id: 4,
    icon: 'ri-leaf-line',
    title: 'Nachhaltigkeit',
    description: 'Ressourcenschonendes Bauen ist uns wichtig. Wir setzen auf umweltfreundliche Materialien und minimieren Abfälle auf unseren Baustellen.',
  },
  {
    id: 5,
    icon: 'ri-team-line',
    title: 'Teamgeist',
    description: 'Unser Team aus Fachleuten verschiedener Disziplinen arbeitet Hand in Hand. Zusammenhalt, gegenseitiger Respekt und Weiterbildung prägen unsere Unternehmenskultur.',
  },
  {
    id: 6,
    icon: 'ri-lightbulb-line',
    title: 'Innovation',
    description: 'Wir investieren kontinuierlich in neue Technologien, moderne Maschinen und die Weiterentwicklung unserer Mitarbeiter — damit wir immer einen Schritt voraus sind.',
  },
];

export const companyStats = [
  { value: '2021', label: 'Gegründet' },
  { value: '20+', label: 'Jahre Teamkompetenz' },
  { value: '3+', label: 'Leistungssparten' },
  { value: '100%', label: 'Verlässliche Partner' },
];

export const facilitySparten = [
  {
    id: 1,
    icon: 'ri-building-2-line',
    title: 'Gebäudeinstandhaltung',
    subtitle: 'Alles am Laufen halten',
    description: 'Regelmäßige Wartung, Inspektion und Reparatur von Gebäuden und technischen Anlagen. Wir sorgen dafür, dass Ihre Immobilie langfristig in einwandfreiem Zustand bleibt — reaktiv bei Störungen, präventiv für maximale Lebensdauer.',
    leistungen: ['Wartung & Inspektion', 'Kleinreparaturen', 'Haustechnik', 'Objektbetreuung'],
    color: 'from-[#0D2B4E]/8 to-[#0D2B4E]/3',
    accent: 'bg-[#0D2B4E]',
  },
  {
    id: 2,
    icon: 'ri-tools-line',
    title: 'Renovierung & Erneuerung',
    subtitle: 'Neues Leben für Gebäude',
    description: 'Von der Badsanierung über Malerarbeiten bis zur kompletten Kernsanierung — wir erneuern, was erneuert werden muss. Mit eigenem Fachpersonal für die meisten Gewerke und starken Partnerunternehmen für Spezialaufgaben.',
    leistungen: ['Sanierung & Umbau', 'Malerarbeiten', 'Bodenbeläge', 'Vollsanierungen'],
    color: 'from-[#C8860A]/8 to-[#C8860A]/3',
    accent: 'bg-[#C8860A]',
  },
  {
    id: 3,
    icon: 'ri-sparkling-line',
    title: 'Gebäudereinigung',
    subtitle: 'Sauberkeit auf Profiniveau',
    description: 'Professionelle Reinigung für Büros, Wohngebäude, Treppenhäuser, Industrie- und Gewerbeobjekte. Ob Unterhaltsreinigung, Grundreinigung oder Sonderreinigung — wir liefern hygienische Sauberkeit, auf die man sich verlassen kann.',
    leistungen: ['Unterhaltsreinigung', 'Grundreinigung', 'Treppenhausreinigung', 'Baureinigung'],
    color: 'from-emerald-600/8 to-emerald-600/3',
    accent: 'bg-emerald-600',
  },
];
